import _ from "underscore";
import rison from "rison";
import DriveView from "../../../DriveView";
import ViewDvirView from "../../dvir/view";
import { InspectionType } from "../inspectionHelper";
import { PageLevel } from "../../../store/mobile/types";

import pageHTML from "./review.tmpl";
import DVIRLog from "../../../model/DVIRLog";

export default class ReviewDvirView extends DriveView<any> {

    model: DVIRLog;
    private readonly template = _.template(pageHTML);
    private viewDvirView: ViewDvirView | null;

    /*
    * Initialize the view, set up a new dvir report, precompile the template, bind model change to render event
    */
    constructor (options) {
        super(options, {
            title: "Asset Inspection",
            activeSection: "inspection",
            pageLevel: PageLevel.ASSET_SPECIFIC_PAGE
        });

        if (!options.state) {
            return;
        }

        let id = options.state.id;
        if (id) {
            this.model = new DVIRLog({ id: id });
            this.app.dvirLogsService.resetProperties(this.model);

            if (!this.model.isActive()) {
                // If the model does not have a vehicle or a trailer then it's probably been removed, so we need to reroute
                return;
            }
        } else {
            // no id, can't load log, nothing to do here
            return;
        }

        this.viewDvirView = new ViewDvirView({
            app: this.app,
            state: { id },
            inspection: true,
            isOntario: options.state.isOntario
        });
    }

    render () {
        this.renderImpl();
        return this;
    }

    renderImpl () {
        if (!this.model || !this.model.isActive()) {
            this.app.router.navigate(`inspection/main,${ rison.encode({ type: InspectionType.DVIR_MAIN }) }`, true);
            return undefined;
        }

        return this.display(this.template({})).then(() => {
            this.viewDvirView && this.viewDvirView.setElement(document.getElementById("view-panel")).render();
        });
    }

    remove () {
        this.viewDvirView && this.viewDvirView.remove();
        this.viewDvirView = null;

        super.remove();
        return this;
    }

    switchLanguage(language: string): void {
        this.viewDvirView && this.viewDvirView.switchLanguage(language);
    }
}
